import React, { useContext } from 'react';
import DOMPurify from 'dompurify';
import TranslationsContext from '../TranslationsContext';

export default function ThankYouStep({ sectionsAlreadyOnThePage }) {
	const t = useContext(TranslationsContext);

	return (
		<>
			<div
				className="rich-text text-width-large column small-12"
				dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sectionsAlreadyOnThePage[5]) }}
			/>
			<div
				className="subscriptions-configurator__buttons-wrapper column small-12 flex-container flex-dir-row align-spaced section-spacing-padding flex-wrap"
				style={{ gap: '10px' }}
			>
				<a href="/collections/all" className="button button--border-green white">
					{t('continue_shopping')}
				</a>
				<a
					href="/checkout"
					className="button button--gradient-green"
				>
					{t('proceed_to_checkout')}
				</a>
			</div>
		</>
	);
}
